import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchRoles } from "../../api/Assignee.api";
import { IRoles, ILeadUser } from "../../models/LeadData.model";

interface commonState {
  userBasedOnRoles: ILeadUser[];
  isOpenAddLead: boolean;
  loading: boolean;
  roles: IRoles;
}

const initialState: commonState = {
  isOpenAddLead: false,
  loading: false,
  userBasedOnRoles: [],
  roles: {
    userBasedOnRoles: [],
    manager: undefined,
  },
};

export const extractRoles = createAsyncThunk(
  "users/extractRoles",
  async (_, { rejectWithValue }): Promise<any> => {
    try {
      return await fetchRoles();
    } catch (error: any) {
      return rejectWithValue(error?.message || "Failed to fetch Kanban data");
    }
  }
);

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    updateIsOpenAddLead: (state, action) => {
      state.isOpenAddLead = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(extractRoles.pending, (state) => {
        state.loading = true;
      })
      .addCase(extractRoles.fulfilled, (state, action) => {
        state.loading = false;
        state.roles = action.payload;
      })
      .addCase(extractRoles.rejected, (state, action) => {
        state.loading = false;
      });
  },
});
export const { setLoading, updateIsOpenAddLead } = commonSlice.actions;
export default commonSlice.reducer;
